module.exports = __webpack_public_path__ + "static/media/Mongolia.7be9eec1.png";